module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-num"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Chronology of Events Leading to The War of 2015–2018")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2009")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("America launches "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Space Station Alpha")]), _vm._v(". Built and supplied by numerous shuttle launches, the space station houses a crew of sixty scientists and engineers. It is a proud day for the United States, but there is considerable grumbling among members of Congress about the cost of the project. Many think the money could have been better used to provide services for the country’s growing number of homeless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elsewhere in the world, skirmishes, minor wars, droughts, famines and overpopulation have brought global economy to the brink of disaster. Struggling with its own financial problems, the United States can no longer provide financial assistance to other regions.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2010")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Senator Lawrence Everette, a black Democrat from Ohio, announces his bid for the presidency. An outspoken advocate of racial equality, he vows to increase spending for the homeless and needy, rebuild America’s inner-city areas, ")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("and end the stranglehold big business has on government. Although his plans don’t sit well with those already empowered in Washington, he proves to be a popular choice with the people and soon leads the race.")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2011")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("NASA atmospheric scientist Leon Cane publishes a report in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scientific American")]), _vm._v(" linking the space program to violent weather patterns throughout the world. His article creates a national scandal, causing Congress to stop all NASA funding, and ground shuttle launches, until a solution to the problem can be found.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2012")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lawrence Everette is elected President of the United States. Four days later he is assassinated by a white extremist in a chemical bomb attack. Riots break out in Los Angeles, Miami, New York and Atlanta. The U.S. government responds by sending in the National Guard.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2013")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("May—The New Madrid Fault in southern Missouri shifts, causing an earthquake of 9.1 magnitude. St. Louis and numerous other Midwestern cities are destroyed. Thousands are killed, millions left homeless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The United States government is slow in responding to the situation in the Midwest, which leads to rioting and looting. The cry of “Remember Everette” becomes the official anthem of the poor, the homeless and the oppressed. In an attempt to stamp out the flames of revolution, the government sends federal troops into the area.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("November—Tensions reach an all-time high as winter sets in. Millions of people are still homeless, many more lack food, fresh water and the other basic necessities of life. St. Louis, Chicago, Kansas City, Nashville and other cities ")]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("erupt in fighting. Additional troops are called into these areas, but many minority soldiers refuse to fire on their own people. A rift develops in the military ranks.")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2014")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The nation teeters on the brink of civil war. More troops are called for, but the government no longer has the funds to supply them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Emergency food and relief efforts grind to a halt as funding runs out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Numerous insurance companies file for bankruptcy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("July 8—The stock market crashes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thousands of banks fail. Many more are forced to close their doors, declaring a bank holiday to prevent customers from making massive withdrawals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The U.S. economy fails and the country enters another major depression.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stranded since shuttle launches were halted, with little hope of coming home, the crew of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Space Station Alpha")]), _vm._v(" begins to fight. A fire is started, which escalates in the oxygen-rich atmosphere. Millions watch at home, horrified, as all those aboard the space station die. NASA collapses, and with it dies the dream of space exploration.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2015")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a last-ditch effort to prevent a possible race war, General Wyatt Dixon, one of America’s most distinguished black officers, attempts to seize control of the army. His efforts fail and the United States military splits in half, with minority soldiers lining up behind Dixon. Fighting breaks out on military bases around the country. For the first time since the Civil War, American soldiers are fighting one another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The public school system fails.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Social Security and Welfare fail.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2015–2018")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Race war. Millions die, millions more are left homeless. Food shortages. Nationwide famine. Widespread disease.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neighborhoods become walled communities as everyone tries to hold on to what little they have. Many towns and cities no longer have electricity or running water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The governments of numerous Third World nations collapse as the United States is no longer able to support them. Mass panic and riots sweep through Europe, Asia, Africa and Latin America.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2019")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The race war finally grinds to a halt with leaders from both sides signing a peace agreement. People of color have seized control of a great deal of power and land.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The United States begins the slow and difficult process of climbing out of the ashes. Millions have lost homes and loved ones during the conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Broke and virtually powerless, the federal government delegates much of its authority to individual state governments. These governments set taxes as they see fit and provide what benefits they can for their citizens. States that are still productive, and suffered little in the war, are swamped by an influx of refugees from neighboring states, forcing some to close their borders to outsiders. Even then, they do not have the money, or the manpower, to stop the flow of refugees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Along the nation’s highways, shantytowns and tent cities have been erected. Many are home to impoverished refugees and victims of the war, a place to start over for those who have lost almost everything. Others are the domain of prostitutes, bandits and those who prey on weak and weary travelers.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e014e3c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Chronology.vue
// module id = 78
// module chunks = 0